import Price from '../Price';
import Volume from '../Volume';
import { Stack, Typography, Paper, Box, Divider, NumberInput } from '@newulife/common';
import formatImageSrc from 'helpers/formatImageSrc';

export default function ProductSubscriptionOnlyCard({
  useNewDesign = false,
  AutoShipPrice,
  subscribeText,
  imgSrc,
  imgAlt,
  title,
  cv,
  qv,
  price,
  qty,
  maxQty,
  decrement,
  increment,
}) {
  return !useNewDesign ? (
    <Paper
      elevationVariant="card"
      active={qty > 0}
      data-testid={`${title?.replace(/\W/g, '')}-card`}
      sx={{
        display: 'inline-grid',
        width: '100%',
        height: '100%',
      }}
      className="product-card"
    >
      <Stack
        display="grid"
        p={{
          xs: 1.5,
          md: 2,
        }}
        pb={0}
        height="100%"
        width="100%"
        maxWidth="340px"
        justifySelf="center"
      >
        <Stack
          display="grid"
          gap={{
            md: 3,
          }}
          gridTemplateColumns={{
            md: 'auto 1fr',
          }}
          justifyItems={{
            xs: 'center',
            md: 'initial',
          }}
          height="100%"
          mb={2}
        >
          <Box
            width="120px"
            height="120px"
            sx={{
              img: {
                width: '100%',
                height: 'auto',
              },
            }}
          >
            <img src={formatImageSrc(imgSrc)} alt={imgAlt} />
          </Box>
          <Stack gap={1}>
            <Typography variant="body2" textAlign="center">
              {title}
            </Typography>
            <Divider light />
            {cv && qv && (
              <>
                <Stack color="#747679" gap={0.5}>
                  <Typography variant="subbody2">
                    <Volume type="cv" value={cv} />
                  </Typography>
                  <Typography variant="subbody2">
                    <Volume type="qv" value={qv} />
                  </Typography>
                </Stack>
                <Divider light />
              </>
            )}
            <Typography
              data-testid={`${title?.replace(/\W/g, '')}-price`}
              variant="header2"
              color="neutralCool.dark"
              sx={{
                fontWeight: 500,
              }}
            >
              <Price value={price} />
            </Typography>
          </Stack>
        </Stack>
        <Divider
          sx={{
            opacity: 0.6,
            mb: 2,
          }}
        />
        <Stack direction="row" justifyContent="space-between" alignItems="center" gap={2}>
          <NumberInput
            data-testid={`${title?.replace(/\W/g, '')}-footer`}
            min={0}
            max={maxQty}
            value={qty}
            onChange={(data) => {
              data > qty ? increment() : decrement();
            }}
            IconButtonProps={{
              sx: {
                // app.min.css breaks the button states
                '&:active, &:focus, &:hover': {
                  backgroundColor: '#fff',
                  color: '#7ab800',
                },
              },
            }}
          />
          <Typography variant="subbody2" color="neutralCool.dark">
            {subscribeText}
          </Typography>
        </Stack>
      </Stack>
    </Paper>
  ) : (
    <Paper
      elevationVariant="card"
      active={qty > 0}
      borderColorActive="primary"
      data-testid={`${title?.replace(/\W/g, '')}-card`}
      sx={{
        display: 'inline-grid',
        width: '100%',
        height: '100%',
      }}
      className="product-card"
    >
      <Stack
        display="grid"
        gridTemplateRows="auto 1fr"
        p={{
          xs: 1.5,
          md: 2,
        }}
        pb={0}
        height="100%"
        width="100%"
        maxWidth="340px"
        justifySelf="center"
      >
        <Stack
          display="grid"
          gap={{
            md: 3,
          }}
          gridTemplateColumns={{
            md: 'auto 1fr',
          }}
          justifyItems={{
            xs: 'center',
            md: 'initial',
          }}
          height="100%"
          mb={2}
        >
          <Box
            width="120px"
            height="120px"
            sx={{
              img: {
                width: '100%',
                height: 'auto',
              },
            }}
          >
            <img src={formatImageSrc(imgSrc)} alt={imgAlt} />
          </Box>
          <Stack gap={1}>
            <Typography variant="body2" textAlign="left">
              {title}
            </Typography>
            <Divider sx={{ opacity: 0.6 }} />
            {cv && qv && (
              <>
                <Stack color="#747679" gap={0.5}>
                  <Typography variant="subbody2">
                    <Volume type="cv" value={cv} />
                  </Typography>
                  <Typography variant="subbody2">
                    <Volume type="qv" value={qv} />
                  </Typography>
                </Stack>
                <Divider sx={{ opacity: 0.6 }} />
              </>
            )}
            <Typography
              data-testid={`${title?.replace(/\W/g, '')}-price`}
              variant="header2"
              color="neutralCool.dark"
              sx={{
                fontWeight: 500,
              }}
            >
              <Price value={AutoShipPrice?.Price || price} />
            </Typography>
          </Stack>
        </Stack>

        {/* Footer Section */}
        <Box
          sx={{
            backgroundColor: qty > 0 ? '#e6edff' : '#f0f0f0',
            borderRadius: 2,
            p: 1.5,
            transition: 'background-color 0.3s ease',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 1.25,
          }}
        >
          <Typography variant="body1" color="neutralCool.dark" textAlign="center">
            {subscribeText}
          </Typography>
          <NumberInput
            data-testid={`${title?.replace(/\W/g, '')}-footer`}
            min={0}
            max={maxQty}
            value={qty}
            onChange={(data) => {
              data > qty ? increment() : decrement();
            }}
            IconButtonProps={{
              sx: {
                color: '#012169',
                '&:active, &:focus, &:hover': {
                  backgroundColor: '#fff',
                  color: '#012169',
                },
              },
            }}
          />
        </Box>
      </Stack>
    </Paper>
  );
}
